<template>
  <div class="container-fluid">
    <div class="panel panel-info">
      <!-- <div style="text-align: left" class="p-3 mb-2">
        <h4>
          Request Received
          <b-button class="float-right"  variant="danger" @click="handleBack">Back</b-button>
        </h4>
        <hr />
      </div> -->
      <div class="p-3 mb-2 col-12">
    <h5>Request Received:
     <b-btn
          class="btn-danger float-right"
           style="text-align: right;"
          @click="handleBack()"
        >
         <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
        </b-btn></h5>
      </div>
      <p> Request received for Transport Certificate</p>
      <div class="panel-body">
        <div>
          <div class="md-4">
            <b-card >
            <b-card-text class="mycard" @click="viewHandle1">
              <table style="">
                <tr>
                  <td  style="text-align: left">Vehicle No</td>
                  <td style="text-align: left">:</td>
                  <td style="text-align: left">MH04-BQ-3443</td>
                  <td>
                    <b-badge variant="light"><b-icon-check-circle style="color:green;font-size:25px;"></b-icon-check-circle></b-badge>
                  </td>
                  <!-- <td>
                    <b-dropdown
                      size="sm"
                      variant="link"
                      dropleft text="Drop-Left"
                      toggle-class="text-decoration-none"
                      no-caret
                     
                    >
                      <template #button-content>
                       <b-icon-three-dots-vertical></b-icon-three-dots-vertical><span class="sr-only">Action</span>
                      </template>
                      <b-dropdown-item @click="viewHandle">View</b-dropdown-item>
                    </b-dropdown>
                  </td> -->
                </tr>
                <tr>
                  <td width="45%" style="text-align: left">Driver Name</td>
                  <td width="1%" style="text-align: left">:</td>
                  <td width="54%" style="text-align: left">Satish S Patil</td>
                  
                </tr>

                <tr>
                  <td width="45%" style="text-align: left">Transport From</td>
                  <td width="1%" style="text-align: left">:</td>
                  <td width="54%" style="text-align: left">Kolhapur</td>
                </tr>
                <tr>
                  <td width="45%" style="text-align: left">Transport To</td>
                  <td width="1%" style="text-align: left">:</td>
                  <td width="54%" style="text-align: left">Sangli</td>
                </tr>
              </table>
            </b-card-text>
            </b-card>
          </div><br/>
          <div class="md-4">
            <b-card>
            <b-card-text  @click="viewHandle" class="mycard" style="padding-top: 1px">
              <table style="">
                <tr>
                  <td width="45%" style="text-align: left">Vehicle No</td>
                  <td width="1%" style="text-align: left">:</td>
                  <td width="54%" style="text-align: left">MH07-BR-1289</td>
                  <td>
                    <b-dropdown
                      size="sm"
                      variant="link"
                      dropleft text="Drop-Left"
                      toggle-class="text-decoration-none"
                      no-caret
                     
                    >
                      <template #button-content>
                       <b-icon-three-dots-vertical></b-icon-three-dots-vertical><span class="sr-only">Action</span>
                      </template>
                      
                      <b-dropdown-item href="#">Edit</b-dropdown-item>
                      <b-dropdown-item href="#">Delete</b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
                <tr></tr>

                <tr>
                  <td width="45%" style="text-align: left">Driver Name</td>
                  <td width="1%" style="text-align: left">:</td>
                  <td width="54%" style="text-align: left">Suraj K Surve</td>
                </tr>
                <!-- <tr>
                    <td width="45%" style="text-align:left">Animal Type</td>
                    <td width="1%" style="text-align:left">:</td>
                    <td width="54%" style="text-align:left">**</td>
                  </tr> -->
                <tr>
                  <td width="45%" style="text-align: left">Transport From</td>
                  <td width="1%" style="text-align: left">:</td>
                  <td width="54%" style="text-align: left">Latur</td>
                </tr>
                <tr>
                  <td width="45%" style="text-align: left">Transport To</td>
                  <td width="1%" style="text-align: left">:</td>
                  <td width="54%" style="text-align: left">Pune</td>
                </tr>
              </table>
            </b-card-text>
            </b-card>
          </div>
<br/>
          <div class="md-4">
            <b-card>
            <b-card-text  @click="viewHandle" class="mycard" style="padding-top: 5px">
              <table style="">
                <tr>
                  <td width="45%" style="text-align: left">Vehicle No</td>
                  <td width="1%" style="text-align: left">:</td>
                  <td width="54%" style="text-align: left">MH08-RT-7007</td>
                  <td>
                    <b-dropdown
                      size="sm"
                      variant="link"
                      dropleft text="Drop-Left"
                      toggle-class="text-decoration-none"
                      no-caret
                     
                    >
                      <template #button-content>
                       <b-icon-three-dots-vertical></b-icon-three-dots-vertical><span class="sr-only">Action</span>
                      </template>
                     
                      <b-dropdown-item href="#">Edit</b-dropdown-item>
                      <b-dropdown-item href="#">Delete</b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
                <tr></tr>
                <tr>
                  <td width="45%" style="text-align: left">Driver Name</td>
                  <td width="1%" style="text-align: left">:</td>
                  <td width="54%" style="text-align: left">Kumar s Patel</td>
                </tr>
                <!-- <tr>
                    <td width="45%" style="text-align:left">Animal Type</td>
                    <td width="1%" style="text-align:left">:</td>
                    <td width="54%" style="text-align:left">**</td>
                  </tr> -->
                <tr>
                  <td width="45%" style="text-align: left">Transport From</td>
                  <td width="1%" style="text-align: left">:</td>
                  <td width="54%" style="text-align: left">Nashik</td>
                </tr>
                <tr>
                  <td width="45%" style="text-align: left">Transport To</td>
                  <td width="1%" style="text-align: left">:</td>
                  <td width="54%" style="text-align: left">Pune</td>
                </tr>
              </table>
            </b-card-text>
            </b-card>
          </div>

          <!-- <b-button
              type="button"
              size="sm"
              variant="primary"
              style="float: right"
              >
            
            <router-link
                        style="color:white;"
                        :to="{ name: 'medical'}"
                      >View</router-link>
            
             </b-button> -->
             <br/>
          
          
         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    viewHandle1(){
      this.$router.push('/home/transport_certificate');
    },
    viewHandle(){
      this.$router.push('/home/req_certificate');
    },
    handleBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
table {
  font-family: arial, sans-serif;
  line-height: 1;
  width: 100%;
}

td,
th {
  border: 0px solid #dddddd;
  text-align: left;
  padding: 2px;
}
.mycard {
  padding-top: 5px !important;
  padding-bottom: 5px;
}
body {
  line-height: 1;
}
</style>
